import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiClock, FiUsers, FiStar, FiMapPin, FiArrowRight } from 'react-icons/fi';
import './TripCard.css';

const TripCard = ({ trip }) => {
  const coverImage = trip.coverImage || '/ladakh.jpg';

  return (
    <motion.div
      className="trip-card"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -6 }}
      transition={{ duration: 0.3 }}
    >
      <div className="card-image">
        <img src={coverImage} alt={trip.title} loading="lazy" onError={(e) => { e.target.src = '/ladakh.jpg'; }} />
        <div className="card-overlay" />
        <div className="card-badges">
          {trip.featured && <span className="badge featured">Featured</span>}
          {trip.upcoming && <span className="badge upcoming">Upcoming</span>}
          <span className={`badge difficulty ${trip.difficulty?.toLowerCase()}`}>{trip.difficulty}</span>
        </div>
        <div className="card-category">{trip.category}</div>
      </div>
      <div className="card-body">
        <div className="card-destination">
          <FiMapPin />
          <span>{trip.destination}</span>
        </div>
        <h3 className="card-title">{trip.title}</h3>
        <p className="card-desc">{trip.description?.substring(0, 100)}...</p>
        <div className="card-meta">
          <span><FiClock /> {trip.duration}</span>
          <span><FiUsers /> Max {trip.maxGroupSize}</span>
          <span><FiStar /> {trip.rating}</span>
        </div>
        <div className="card-footer">
          <div className="card-price">
            {trip.originalPrice && <span className="original-price">₹{trip.originalPrice?.toLocaleString()}</span>}
            <span className="current-price">₹{trip.price?.toLocaleString()}</span>
            <span className="per-person">/ person</span>
          </div>
          <Link to={`/trips/${trip._id}`} className="card-btn">
            Explore <FiArrowRight />
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default TripCard;
